import axios from "./request";
const getUserInfo = () => {
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  return user || {};
};
export const ExportPurchase = (start_date, end_date, id) => {
  return `/index/index/purchase_derive?start_date=${start_date}&end_date=${end_date}&id=${id.join(
    ","
  )}`;
};
export const GetPurchaseList = params => {
  const { page, start_date, end_date } = params;
  const data = new FormData();
  data.append("page", page);
  data.append("start_date", start_date);
  data.append("end_date", end_date);

  return axios.post("/purchase_list", data);
};
export const GetTopicAnalyze = () => {
  return axios.post("/topic_statistics");
};

export const validatePurchase = () => {
  const { id: uid } = getUserInfo();
  return axios.post("/purchase_detection", { data: { uid } });
};



// WEBPACK FOOTER //
// ./src/request/adminPurchase.js